import type { AlertChannel, AlertEvent, AlertRoute } from '../../api/notifications.api.js';

import type { PendingChange } from './settings-changes';

/**
 * The routes the Alert routing page is about to change, for the save bar
 * (DEV-137). `edits` holds the channel chosen per event key (null: console
 * only); a choice equal to what is stored is not a change. The key of each
 * change is the event key, which is what the save sends.
 */

const CONSOLE_ONLY = 'Console only';

export function routePendingChanges(
  events: readonly AlertEvent[],
  channels: readonly AlertChannel[],
  routes: readonly AlertRoute[],
  edits: Readonly<Record<string, string | null>>,
): PendingChange[] {
  const stored = new Map(routes.map((r) => [r.eventKey, r.channelId]));
  const name = (id: string | null): string => (id === null ? CONSOLE_ONLY : (channels.find((c) => c.id === id)?.name ?? id));
  return events
    .filter((event) => event.key in edits && (edits[event.key] ?? null) !== (stored.get(event.key) ?? null))
    .map((event) => ({
      key: event.key,
      label: event.label,
      before: name(stored.get(event.key) ?? null),
      after: name(edits[event.key] ?? null),
      secret: false,
      needsReason: false,
    }));
}
